import React from "react";
import { Col, Layout, message, Row, Select, Icon } from "antd";
import moment from "moment";
import MiCompAPI from "../../util/api";
import ReportTableWrapper from "../elements/ReportTableWrapper";
import ExportJsonExcel from "js-export-excel";
const { Content } = Layout;
const { Option } = Select;
class EnrollmentSummary extends React.Component {
  // columns = [{
  //     title: 'Policy Id/Folio Id',
  //     dataIndex: 'policy_id',
  //     sorter: (a, b) => a.client_plan_Id.localeCompare(b.client_plan_Id),
  //     sortDirections: ["descend", "ascend"]
  // }, {
  //     title: 'Enrollee Name',
  //     dataIndex: 'enrollee_name',
  //     sorter: (a, b) => a.plan_Name.localeCompare(b.plan_Name),
  //     sortDirections: ["descend", "ascend"]
  // },
  // {
  //     title: 'Date of Enrollment',
  //     dataIndex: 'date_of_enrollment',
  //     render: (text, record) => record["date_of_enrollment"] !== null && record["date_of_enrollment"] !== "" ? moment(record["date_of_enrollment"]).format("MM/DD/YYYY") : "none",
  //     sorter: (a, b) => new Date(a.date_of_enrollment) - new Date(b.date_of_enrollment),
  //     sortDirections: ["descend", "ascend"]
  // }, {
  //     title: 'Date of Disenrollment',
  //     dataIndex: 'date_of_disenrollment',
  //     render: (text, record) => record["date_of_disenrollment"] !== null && record["date_of_disenrollment"] !== "" ? moment(record["date_of_disenrollment"]).format("MM/DD/YYYY") : "none",
  //     sorter: (a, b) => new Date(a.date_of_disenrollment) - new Date(b.date_of_disenrollment),
  //     sortDirections: ["descend", "ascend"]
  // },
  // {
  //     title: 'Amount/Lives',
  //     dataIndex: 'isAmount',
  //     render: (text, record) => record["isAmount"] !== null && record["isAmount"] !== "" ? record["isAmount"] : "none",
  // },
  // {
  //     title: 'Plan Id',
  //     dataIndex: 'plan_Id',
  //     sorter: (a, b) => a.plan_Id.localeCompare(b.plan_Id),
  //     sortDirections: ["descend", "ascend"]
  // }, {
  //     title: 'Plan Name',
  //     dataIndex: 'plan_name',
  //     sorter: (a, b) => a.plan_name.localeCompare(b.plan_name),
  //     sortDirections: ["descend", "ascend"]
  // }, {
  //     title: 'Commission Profile',
  //     dataIndex: 'tier_profile_name',
  //     sorter: (a, b) => a.tier_profile_name.localeCompare(b.tier_profile_name),
  //     sortDirections: ["descend", "ascend"]
  // }];
  // constructor(props) {
  //     super(props);
  //     this.state = {
  //         enrollmentreport: null,
  //         isLoading: false,
  //         months: [],
  //         years: [],
  //         month: new Date().getMonth() + 1,
  //         year: new Date().getFullYear()
  //     }
  //     this.tableButtons = [{
  //         buttonType: "primary",
  //         content: "Export Excel",
  //         clickHandler: () => {
  //             this.downloadExcel();
  //         }
  //     }];
  //     this.api = new MiCompAPI(this.props.userPermandMasters);
  // }
  // getClientMasters() {
  //     this.api.invoke(
  //         "GetMasters",
  //         "post",
  //         (data, success) => {
  //             if (success) {
  //                 this.setState({
  //                     months: data.months,
  //                     years: data.years
  //                 });
  //             }
  //         },
  //         ["MTH", "YR"]
  //     );
  // }
  // downloadExcel = () => {
  //     const { decodedToken } = this.props.userPermandMasters;
  //     var role = decodedToken.UserRoleName;
  //     const data = this.state.enrollmentreport ? this.state.enrollmentreport : '';//tabular data
  //     var option = {};
  //     let dataTable = [];
  //     if (data) {
  //         for (let i in data) {
  //             if (data) {
  //                 if (role !== 'broker') {
  //                     let obj = {
  //                         'Policy ID/Folio ID': data[i].policy_id,
  //                         'Enrollee Name': data[i].enrollee_name,
  //                         'Amount/Lives': data[i].isAmount,
  //                         'Date of Enrollment': data[i].date_of_enrollment ? moment(data[i].date_of_enrollment).format("MM/DD/YYYY") : null,
  //                         'Date of Disenrollment': data[i].date_of_disenrollment ? moment(data[i].date_of_disenrollment).format("MM/DD/YYYY") : null,
  //                         'Plan ID': data[i].plan_Id,
  //                         'Plan Name': data[i].plan_name,
  //                         'Commission Profile': data[i].tier_profile_name,
  //                         'Broker Name': data[i].broker_Name,
  //                     }
  //                     dataTable.push(obj);
  //                 } else {
  //                     let obj = {
  //                         'Policy ID/Folio ID': data[i].policy_id,
  //                         'Enrollee Name': data[i].enrollee_name,
  //                         'Amount/Lives': data[i].isAmount,
  //                         'Date of Enrollment': data[i].date_of_enrollment ? moment(data[i].date_of_enrollment).format("MM/DD/YYYY") : null,
  //                         'Date of Disenrollment': data[i].date_of_disenrollment ? moment(data[i].date_of_disenrollment).format("MM/DD/YYYY") : null,
  //                         'Plan ID': data[i].plan_Id,
  //                         'Plan Name': data[i].plan_name,
  //                         'Commission Profile': data[i].tier_profile_name,
  //                     }
  //                     dataTable.push(obj);
  //                 }
  //             }
  //         }
  //     }
  //     option.fileName = 'Enrollment'
  //     if (role !== 'broker') {
  //         option.datas = [
  //             {
  //                 sheetData: dataTable,
  //                 sheetName: 'sheet',
  //                 sheetFilter: ['Policy ID/Folio ID', 'Enrollee Name', 'Amount/Lives', 'Date of Enrollment', 'Date of Disenrollment', 'Plan ID', 'Plan Name', 'Commission Profile', 'Broker Name'],
  //                 sheetHeader: ['Policy ID/Folio ID', 'Enrollee Name', 'Amount/Lives', 'Date of Enrollment', 'Date of Disenrollment', 'Plan ID', 'Plan Name', 'Commission Profile', 'Broker Name'],
  //             }
  //         ];
  //     } else {
  //         option.datas = [
  //             {
  //                 sheetData: dataTable,
  //                 sheetName: 'sheet',
  //                 sheetFilter: ['Policy ID/Folio ID', 'Enrollee Name', 'Amount/Lives', 'Date of Enrollment', 'Date of Disenrollment', 'Plan ID', 'Plan Name', 'Commission Profile'],
  //                 sheetHeader: ['Policy ID/Folio ID', 'Enrollee Name', 'Amount/Lives', 'Date of Enrollment', 'Date of Disenrollment', 'Plan ID', 'Plan Name', 'Commission Profile'],
  //             }
  //         ];
  //     }
  //     if(dataTable.length>0){
  //         var toExcel = new ExportJsonExcel(option);
  //         toExcel.saveExcel();
  //     }
  // }
  // componentDidMount = () => {
  //     const { decodedToken } = this.props.userPermandMasters;
  //     var role = decodedToken.UserRoleName;
  //     this.getClientMasters();
  //     if (role !== 'broker') {
  //         this.columns.push({
  //             title: 'Broker Name',
  //             dataIndex: 'broker_Name',
  //             sorter: (a, b) => a.broker_Name.localeCompare(b.tier_profile_name),
  //             sortDirections: ["descend", "ascend"]
  //         });
  //     }
  //     this.GetEnrollementReport(this.state.month, this.state.year);
  // }
  // onChange = (type, e) => {
  //     if (type === "year") {
  //         this.setState({
  //             year: e
  //         });
  //     }
  //     if (type === "month") {
  //         this.setState({
  //             month: e
  //         });
  //     }
  //     if (this.state.year && this.state.month) {
  //         setTimeout(() => {
  //             this.GetEnrollementReport(this.state.month, this.state.year);
  //         }, 100);
  //     }
  // }
  // GetEnrollementReport(month, year) {
  //     this.setState({
  //         isLoading: true
  //     })
  //     this.api.invoke(
  //         "GetAgencyEnrollDetails/" + month + "/" + year,
  //         "get",
  //         (data, success) => {
  //             if (success) {
  //                 if (data.statusCode === 200) {
  //                     this.setState({
  //                         isLoading: false,
  //                         enrollmentreport: data.data
  //                     })
  //                 } else {
  //                     message.destroy();
  //                     message.error(data.statusMessage, 3);
  //                 }
  //             }
  //             this.setState({
  //                 isLoading: false
  //             })
  //         });
  // }
  // render() {
  //     return (
  //         <Content>
  //             <div className="mi_main_div">
  //                 <Row style={{ padding: '20px', background: 'white' }}>
  //                     <Col span={24}>
  //                         <p className="mi_table_title" style={{ textAlign: 'center', marginBottom: '40px' }}>Enrollment Details Report</p>
  //                     </Col>
  //                     <Col span={24} style={{ marginBottom: '40px' }}>
  //                         <Row span={24}>
  //                             <Col span={12} style={{ padding: '0px 20px 0px 0px' }} >
  //                                 <h3><b>Year : </b></h3>
  //                                 <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
  //                                     onChange={this.onChange.bind(this, 'year')}
  //                                     placeholder="Please Select Year *"
  //                                     showSearch={true}
  //                                     optionFilterProp="children"
  //                                     filterOption={(input, option) =>
  //                                         option.props.children
  //                                             .toLowerCase()
  //                                             .indexOf(input.toLowerCase()) >= 0
  //                                     }
  //                                     defaultValue={this.state.year?this.state.year:undefined}
  //                                 >
  //                                     {this.state.years ? this.state.years.map((tag) => (
  //                                         <Option value={tag.id} key={tag.id}>
  //                                             {tag.name}
  //                                         </Option>
  //                                     )) : ''}
  //                                 </Select>
  //                             </Col>
  //                             <Col span={12} style={{ padding: '0px 20px' }}>
  //                                 <h3><b>Month : </b></h3>
  //                                 <Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input_profile"
  //                                     onChange={this.onChange.bind(this, 'month')}
  //                                     placeholder="Please Select Month *"
  //                                     showSearch={true}
  //                                     optionFilterProp="children"
  //                                     filterOption={(input, option) =>
  //                                         option.props.children
  //                                             .toLowerCase()
  //                                             .indexOf(input.toLowerCase()) >= 0
  //                                     }
  //                                     defaultValue={this.state.month?this.state.month:undefined}
  //                                 >
  //                                     {this.state.months ? this.state.months.map((tag) => (
  //                                         <Option value={tag.id} key={tag.id}>
  //                                             {tag.name}
  //                                         </Option>
  //                                     )) : ''}
  //                                 </Select>
  //                             </Col>
  //                         </Row>
  //                     </Col>
  //                     <Col span={24} style={{ marginBottom: '0px' }}>
  //                         <Row span={24}>
  //                             <Col span={12} style={{ display: 'flex' }}>
  //                             </Col>
  //                             <Col span={12} >
  //                                 <h3 style={{ float: 'right' }}><b>	Total Enrollments :</b> {this.state.enrollmentreport && this.state.enrollmentreport.length > 0 ? this.state.enrollmentreport[0].total : 0}</h3>
  //                             </Col>
  //                         </Row>
  //                     </Col>
  //                     <Col span={24}>
  //                         <ReportTableWrapper rowKey="policy_id" columns={this.columns} data={this.state.enrollmentreport ? this.state.enrollmentreport : null} loading={this.state.isLoading} buttons={this.tableButtons} search={true} />
  //                     </Col>
  //                 </Row>
  //             </div>
  //         </Content>
  //     );
  // }
  constructor(props) {
    super(props);

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  render() {
    const { decodedToken } = this.props.userPermandMasters;

    var role = decodedToken.UserRoleName;
    var userdId = decodedToken.UserId;

    return (
      <Content>
        <div className="mi_main_div" style={{ paddingTop: "1px" }}>
          <div
            style={{
              textAlign: "center",
              alignContent: "center",
              marginTop: "3%",
            }}
          >
            {userdId === "10297" && (
             <iframe title="Broker_V1(New)_EnrollmentReport" width="1024" height="612" src="
             https://app.powerbi.com/view?r=eyJrIjoiOGMwZDViZjgtMjIwOS00ZGQ5LThhN2QtM2RkOTkzYzUxNDY1IiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
             frameborder="0" allowFullScreen="true"></iframe>
            )}
            {userdId === "10302" && (
              <iframe title="Carrier_V1(New)_EnrollmentReport" width="1024" height="612" src="
              https://app.powerbi.com/view?r=eyJrIjoiNjQyMDY1ZDAtYjQ4MS00MjNiLWIwMTYtMGY0MDZiNDM5NTU2IiwidCI6ImZjOGM4MTM5LTk1YTktNDRiNC1hMzg0LWQ1YzBhOGExYmQxMCIsImMiOjN9"
              frameborder="0" allowFullScreen="true"></iframe>
            )}
          </div>
          {/* </div> */}
          {/* {dashboard} */}
        </div>
      </Content>
    );
  }
}
export default EnrollmentSummary;
